import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            w: '100%',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        container: {
            maxWidth: remCalc(1432),
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            paddingY: {
                base: 'medium-3.base',
                md: 'medium-3.md',
                lg: 'medium-3.lg',
                xl: 'medium-3.xl',
            },
            paddingX: {
                base: 'medium.base',
                md: 'medium.md',
                lg: 'medium.lg',
                xl: 'medium.xl',
                '2xl': remCalc(0),
            },
        },
    },
}
